const addressProtocols = [
  { label: 'Bitcoin (BTC)', value: 'btc' },
  { label: 'Ethereum (ETH)', value: 'eth' },
  { label: 'Binance Smart Chain (BNB)', value: 'bnb' },
  { label: 'Solana (SOL)', value: 'sol' },
  { label: 'Ripple (XRP)', value: 'xrp' },
  { label: 'Avalanche (AVAX)', value: 'avax' },
  { label: 'Tron (TRX)', value: 'trx' },
  { label: 'Polygon (MATIC)', value: 'matic' },
  { label: 'Litecoin (LTC)', value: 'ltc' },
  { label: 'Bitcoin Cash (BCH)', value: 'bch' },
  { label: 'Stellar (XLM)', value: 'xlm' },
  { label: 'Bitcoin SV (BSV)', value: 'bsv' },
  { label: 'MultiversX (EGLD)', value: 'egld' },
  { label: 'Algorand (ALGO)', value: 'algo' },
  { label: 'Flow (FLOW)', value: 'flow' },
  { label: 'Klaytn (KLAY)', value: 'klay' },
  { label: 'Bitcoin Gold (BTG)', value: 'btg' },
  { label: 'Zcash (ZEC)', value: 'zec' },
  { label: 'Dash (DASH)', value: 'dash' },
  { label: 'Harmony (ONE)', value: 'one' },
  { label: 'Verge Currency (XVG)', value: 'xvg' },
  { label: 'Provenance (HASH)', value: 'hash' },
  { label: 'SUI', value: 'sui' },
  { label: 'EOS', value: 'eos' },
  { label: 'Dogecoin (DOGE)', value: 'doge' },
  { label: 'Cardano (ADA)', value: 'ada' },
  { label: 'Conflux (CFX)', value: 'cfx' },
  { label: 'Cosmos (ATOM)', value: 'atom' },
  { label: 'Ethereum Classic (ETC)', value: 'etc' },
  { label: 'Celo (CELO)', value: 'celo' },
  { label: 'Fantom (FTM)', value: 'ftm' },
  { label: 'Moonbeam (GLMR)', value: 'glmr' },
  { label: 'Cronos (CRO)', value: 'cro' },
  { label: 'Everscale (EVER)', value: 'ever' },
  { label: 'Filecoin (FIL)', value: 'fil' },
  { label: 'Hedera (HBAR)', value: 'hbar' },
  { label: 'Tezos (XTZ)', value: 'xtz' },
  { label: 'Coreum', value: 'coreum' },
];

const getWalletProtocolName = (walletProtocol: string) => {
  const addressProtocol = addressProtocols.find(
    (p) => p.value === walletProtocol
  );

  if (addressProtocol) {
    return addressProtocol.label;
  }

  return walletProtocol;
};

export { getWalletProtocolName };
